export const Border = {
  Radius: "8px",
  RadiusSm: "5px",
  RadiusLg: "12px",
};
